import React from 'react';
import { useAppSelector } from 'store/configureStore';
import { isQldRegion } from 'utils/petFormHelpers';
import Icon from '../../../components/UI/Icon/Icon';

const getStageLabel = (activeStage?: number): string => {
  if (activeStage === 1) return "Submitted by tenant";
  if (!isQldRegion()) return "Landlord to complete";
  return "Submitted by tenant";
};

const TenantHeader: React.FC<{roleType: string, activeStage?: number}> = ({ roleType, activeStage }) => {
  const agentName = useAppSelector((state) => state.Tenant?.agentName ?? '');
  const agentCompany = useAppSelector((state) => state.Tenant?.agentCompany ?? '');

  return (
    <div className="bg-navy pt-60px pb-30px">
      <div className="w-100 max-w-960px px-30px px-lg-0 mx-auto">
        <div className="d-flex flex-column gap-10px fw-bold text-white">
          <div className="fs-25px">
            {roleType === "tenant" ? "Apply" : "Application"} to keep a pet in a rental property{isQldRegion() ? " (Form 21 - QLD)" : ""}
          </div>
          {
            roleType === "agent" || roleType === "landlord" ? (
              <div className="fs-18px">{getStageLabel(activeStage)}</div>
            ) : null
          }
          {
            roleType === "tenant" ? (
              <div className="fs-18px">Tenant to complete</div>
            ) : null
          }
          {
            roleType === "tenant" && (
            <div className='d-flex flex-column'>        
              <div className="fs-14px fw-normal"><Icon name={"MailSent"} size={20} className="min-w-30px" /> This pet application will be submitted to: 
              <div className='my-3px ml-30px'>
                <span className='fw-bold pl-5px'>{agentName}</span>
                <div>
                  <span className='fw-bold pl-5px'>{agentCompany}</span>
                </div>
              </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TenantHeader;
